import React from 'react';

function Footer() {
    return (
        <div className='auteco_footer'>
            <div className="left">
                Todos los derechos reservados. Copyright © Auteco {new Date().getFullYear()}
            </div>
            <div className="separator">|</div>
            <div className="right">
                <a href="https://maquinando.co/" target="_blank" rel="noreferrer">
                    Desarrollado por Maquinando. Go Digital
                </a>
            </div>
        </div>
    );
}

export default Footer;
